/**
 * Labstep
 *
 * @module components/ResourceLocation/Form/ShowEdit/SubOuter
 * @desc ShowEdit form to add sub location to a resource location
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { FormShowEditSearchSelect } from 'labstep-web/core/Form/ShowEdit/SearchSelect';
import type { Resource } from 'labstep-web/models/resource.model';
import type { ResourceItem } from 'labstep-web/models/resource-item.model';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type { IResourceLocationFormShowEditSubOuterProps } from './types';

export const ResourceLocationFormShowEditSubOuter = <
  TParentEntity extends ResourceLocation | ResourceItem | Resource,
>({
  outerLocation,
  parentEntity,
  childKeyName,
}: IResourceLocationFormShowEditSubOuterProps<TParentEntity>) => {
  return outerLocation ? (
    <FormShowEditSearchSelect
      parentEntity={parentEntity}
      childEntityName={ResourceLocation.entityName}
      childKeyName={childKeyName}
      optimistic={false}
      hasValue
      customShow={({ toggle }) => (
        <ActionComponent
          type="icon"
          icon="plus"
          elementProps={{ popup: { content: 'Specify sublocation' } }}
          onClick={toggle}
        />
      )}
      searchSelectProps={{
        value: null,
        createBody: {
          outer_location_guid: outerLocation.guid,
        },
        params: {
          not_guid:
            parentEntity instanceof ResourceLocation
              ? [parentEntity.guid]
              : [],
          outer_location_guid: outerLocation.guid,
        },
        creatable: true,
        isClearable: false,
      }}
    >
      <div />
    </FormShowEditSearchSelect>
  ) : null;
};
